const Storage = {
  isAuthenticated: function (data) {
    const userData = Storage.getUserData();
    if (userData) return true;
    return false;
  },
  setUserData: function (data) {
    localStorage.setItem("user_data", JSON.stringify(data));
  },
  getUserData: function () {
    const user = JSON.parse(localStorage.getItem("user_data"));
    return user !== null ? user : null;
  },
  deleteUserData: function () {localStorage.removeItem("user_data")},
  getUserToken: function () {
    return JSON.parse(localStorage.getItem("user_data"));
  },
  getTheme: function () {
    return localStorage.getItem("theme");
  },
  setTheme: function (color) {
    localStorage.setItem("theme", color);
  },
  setComplain: function (itens) {
    localStorage.setItem("complain", JSON.stringify(itens));
  },
  getComplain: function () {
    return JSON.parse(localStorage.getItem("complain"));
  },
  removeComplain: function () {
    localStorage.removeItem("complain");
  },
  getFeatures: function () {
    const features = JSON.stringify(localStorage.getItem("features"));

    if (typeof features === "object") {
      return features;
    }
    return [];
  },
};

export default Storage;
